import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Bestellvorschlag } from '../bestellvorschlag';

@Component({
    selector: 'kiene-change-bestellmengen-dialog',
    templateUrl: './change-bestellmengen-dialog.component.html',
    styleUrls: ['./change-bestellmengen-dialog.component.scss'],
})
export class ChangeBestellmengenDialogComponent implements OnInit {
    bestellvorschlag: Bestellvorschlag;

    mindestbestandCtrl = new UntypedFormControl();
    mindestbestellmengeCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<ChangeBestellmengenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {
        this.bestellvorschlag = data.bestellvorschlag;
    }

    ngOnInit() {
        this.mindestbestandCtrl.setValue(this.bestellvorschlag.mindestbestand);
        this.mindestbestellmengeCtrl.setValue(this.bestellvorschlag.bestellmenge);
    }

    cancel() {
        this.dialogRef.close();
    }

    save() {
        this.bestellvorschlag.mindestbestand = this.mindestbestandCtrl.value;
        this.bestellvorschlag.bestellmenge = this.mindestbestellmengeCtrl.value;

        this.api
            .updateGeneric(this.apiBaseUrl + 'bestellvorschlag/update_artikel.php', this.bestellvorschlag)
            .subscribe(
                () => {
                    this.messageService.infoMessage('Die Bestellmengen wurden aktualisert');
                    this.dialogRef.close();
                },
                error => {
                    this.messageService.errorMessage('Bestellmengen konnten nicht aktualisiert werden.', error);
                },
            );
    }
}
